import { useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"

const useNews = (featured) => {
  const { allFile } = useStaticQuery(graphql`{
    allFile(filter: { relativePath: { regex: "/^rassegna-stampa\/.*/"}}) {
      edges {
        node {
          name
          childImageSharp {
            fluid(maxWidth: 400) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }`);

  const news = useMemo(() => {
    const mapped = allFile.edges.map(edge => ({
      name: edge.node.name,
      fluid: edge.node.childImageSharp.fluid
    }));
    if (!featured){
      return mapped;
    }else{
      return mapped.slice(0, 6);
    }
  }, [allFile, featured]);

  return news;
}

export default useNews;